import { render, staticRenderFns } from "./Contenttable.vue?vue&type=template&id=603fafa8"
import script from "./Contenttable.vue?vue&type=script&lang=js"
export * from "./Contenttable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports